import React, { useEffect } from "react";
import "./Janmashtami.css";
import Header from "../../../Components/Header/Header";
import SriKrishnaJanmashtami from "../assets/Sri_Krishna_Janmashtami.webp";
import Footer from "../../../Components/Footer/Footer";
import RecentBlogs from "../RecentBlogs/RecentBlogs";
import { Helmet } from "react-helmet-async";

const Janmashtami = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Helmet>
        <title>Sri Krishna Janmashtami 2025 at ISKCON Vijayawada</title>
        <meta
          name="description"
          content="Celebrate Sri Krishna Janmashtami 2025 on Aug 15 at ISKCON Vijayawada. Join the festival with kirtans, abhishekam, prasadam & seva. Entry is free!"
        />
        <meta
          name="keywords"
          content="Janmashtami 2025 Vijayawada,ISKCON Vijayawada Janmashtami,Krishna Janmashtami celebration 2025Janmashtami festival Andhra Pradesh, ISKCON temple events 2025, Janmashtami seva booking, Janmashtami prasadam distribution, Krishna birthday celebration Vijayawada , why do ISKCON devotees observe Ekadashi fasting"
        />
        <meta name="robots" content="index, follow" />
        <meta name="author" content="ISKCON Vijayawada" />
        <meta
          property="og:title"
          content="Sri Krishna Janmashtami 2025 at ISKCON Vijayawada"
        />
        <meta
          property="og:description"
          content="Celebrate Sri Krishna Janmashtami 2025 on Aug 15 at ISKCON Vijayawada. Join the festival with kirtans, abhishekam, prasadam & seva. Entry is free!"
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://www.iskconvijayawada.org/sri-krishna-janmashtami"
        />
        <meta
          property="og:image"
          content="https://www.iskconvijayawada.org/static/media/logo.467e4780dde7b11ae4cf.png"
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Sri Krishna Janmashtami 2025 at ISKCON Vijayawada"
        />
        <meta
          name="twitter:description"
          content="Celebrate Sri Krishna Janmashtami 2025 on Aug 15 at ISKCON Vijayawada. Join the festival with kirtans, abhishekam, prasadam & seva. Entry is free!"
        />
        <meta
          name="twitter:image"
          content="https://www.iskconvijayawada.org/static/media/logo.467e4780dde7b11ae4cf.png"
        />

        {/* Canonical URL */}
        <link
          rel="canonical"
          href="https://www.iskconvijayawada.org/sri-krishna-janmashtami"
        />

        {/* FAQ Structured Data */}

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: [
              {
                "@type": "Question",
                name: "When is Janmashtami 2025 celebrated at ISKCON Vijayawada?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Janmashtami will be celebrated on Friday, August 15, 2025, from 6:00 AM till midnight at ISKCON Vijayawada.",
                },
              },
              {
                "@type": "Question",
                name: "Is there any entry fee to attend the festival?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "No. Entry to ISKCON Vijayawada’s Janmashtami 2025 celebration is completely free and open to all.",
                },
              },
              {
                "@type": "Question",
                name: "Can I book seva or make a donation online?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Yes. You can book various sevas and make donations online at https://www.iskconvijayawada.org/janmashtami2025",
                },
              },
              {
                "@type": "Question",
                name: "Will prasadam be available for all visitors?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Yes. Free Krishna prasadam will be served throughout the day to all devotees and visitors.",
                },
              },
              {
                "@type": "Question",
                name: "Are children allowed to participate?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Absolutely. Special events like fancy dress competitions and Krishna-themed activities are organized for children.",
                },
              },
            ],
          })}
        </script>
      </Helmet>
      <Header />
      <div className="  flex justify-center items-center flex-col w-full h-full  pb-14">
        <div className="heading-sign flex justify-center items-center text-2xl md:text-4xl md:font-bold bg-[#c61d21]">
          <h1 id="blog-heading">
            Sri Krishna Janmashtami 2025 at ISKCON Vijayawada – Celebrate the
            Divine Birth of Lord Krishna
          </h1>
        </div>

        <main className="significance-blog">
          <div className="main-section">
            <div className="banner-img">
              <img src={SriKrishnaJanmashtami} alt="dummy1" />
            </div>

            <div id="text-content">
              <p>
                On August 16, 2025, the city of Vijayawada will witness an
                extraordinary spiritual celebration – the Sri Krishna
                Janmashtami Mahotsav at{" "}
                <b>
                  <a href="http://www.iskconvijayawada.org/">
                    ISKCON Vijayawada
                  </a>
                </b>{" "}
                Join thousands of devotees as we celebrate the divine appearance
                of Lord Sri Krishna, the Supreme Personality of Godhead, with
                unmatched joy, devotion, and grandeur.
                <br />
                <h3 style={{ marginTop: "10px" }}>
                  Why Janmashtami is Spiritually Special
                </h3>{" "}
                <br />
                Over five thousand years ago, Lord Sri Krishna, the Supreme
                Personality of Godhead, appeared on earth to protect dharma and
                reestablish spiritual principles. His life and teachings,
                especially through the Bhagavad-gita and Srimad-Bhagavatam,
                continue to inspire millions. <br />
                <br />
                Janmashtami is not merely a festival; it is an opportunity to
                renew our connection with Lord Krishna, engage in devotional
                service, and seek His divine shelter.
                <h3 style={{ marginTop: "10px" }}>
                  ISKCON Vijayawada Janmashtami 2025 – What’s Happening?
                </h3>{" "}
                <br />
                The celebrations at ISKCON Vijayawada promise a full-day
                spiritual journey from morning till midnight, featuring
                spiritual discourses, engaging kirtans, and divine prasadam for
                all. <br />
                <br />
                ISKCON Vijayawada is celebrating Sri Krishna Janmashtami over
                three grand days — from 15th to 17th August — at two sacred
                locations: the vibrant city-centre Sri Jagannath Mandir in
                Krishna Lanka, and the serene main temple, Sri Radha Shyamsundar
                Mandir, in Undavalli. <br />
                <br />
                Join us for a spiritually uplifting festival filled with vibrant
                rituals, soul-touching kirtans, cultural programs, and prasadam
                seva. From Kalashabhishekam to midnight Maha Arati, witness the
                divine appearance of Lord Krishna in its full devotional glory.
                Celebrate Janmashtami in Vijayawada with ISKCON — where
                tradition, devotion, and community unite.
                <br />
              </p>
              <p>
                <h3>Sri Jagannath Mandir – 15th & 16th August 2025</h3>
                <h4>15th August – 4th Anniversary Celebration </h4> <br />
                <br />
                ● ISKCON Vijayawada celebrates the 4th anniversary of Sri
                Jagannath Mandir with grand spiritual fervour. <br />
                <br />
                ● Special Darshan of Lord Jagannath, Baladev, and Subhadra Devi
                will be available until 8:30 PM.
                <br />
                <br />
                <h4>16th August – Sri Krishna Janmashtami Festivities</h4>
                <br />
                ● Experience the divine Kalashabhishekam, offering sacred
                water-filled pots to the Lord. <br />
                <br />
                ● Experience the divine Maha Shankhabhishekam with Panchamritam,
                bathing the Deities with milk, curd, honey, ghee, and sugar
                through auspicious conch shells. <br />
                <br />
                ● Witness a divine spectacle — 1,000 kilos of flowers gracefully
                offered to Lord Krishna in the majestic Pushpabhishekam
                ceremony. <br />
                <br />
                ● Participate in Krishna Vesha Dharan and the joyful Utti
                Mahotsav, reenacting the playful childhood pastimes of Lord
                Krishna. <br />
                <br />
                ● Enjoy devotional singing, traditional cultural performances,
                and Annadana Seva for all attending devotees.
                <br />
              </p>
              <br />
              <h3>Sri Radha Shyamsundar Mandir – 16th & 17th August 2025</h3>
              <h4>16th August – Sri Krishna Janmashtami Day</h4>
              <p>
                ● Full-day festivities begin at 8:00 AM and continue until
                midnight at ISKCON Vijayawada's main temple. <br />
                <br />
                ● Special rituals include Maha Shankabhishekam and
                Kalashabhishekam, accompanied by Vedic chants and musical
                offerings. <br />
                <br />
                ● Witness the magnificent Pushpabhishekam with 1,000 kgs of
                fresh fragrant flowers, a visual expression of love and devotion
                for the Lord. <br />
                <br />
                ● Relive Vrindavan’s joy through Utti Mahotsav at ISKCON
                Vijayawada — a festival of laughter, devotion, and divine fun
                honoring Krishna’s sweet mischief. <br />
                <br />● Krishna prasadam will be lovingly distributed to
                thousands of devotees after the midnight celebration.
              </p>
              <br />
              <h3>17th August – Nandotsav & Srila Prabhupada Appearance Day</h3>
              <br />
              <p>
                ● The festival concludes with Vyasa Puja celebrations honouring
                Srila Prabhupada, the founder-acharya of ISKCON.
                <br />
                <br />
                ● Glorification, darshan, and offerings will take place from
                10:00 AM to 2:00 PM, accompanied by spiritual discourses and
                kirtan.
                <br />
                <br />
              </p>
              <br />
              <h3>Special Seva Opportunities</h3>
              <p>
                <p>
                  Serve the Lord with love this Janmashtami! Participate in the
                  transcendental festival by offering your time, service, and
                  heartfelt devotion. Seva is open to all devotees, families,
                  and volunteers.
                </p>
                <br />
                <b> Annadana Seva – </b> Sponsor prasadam distribution for
                hundreds of devotees
                <br />
                <br />
                <b> Kalashabhishekam Seva – </b> Participate or sponsor sacred
                abhisheka of the Lord
                <br />
                <br />
                <b>Shankha Abhishekam Seva – </b> Sponsor conch shell bathing of
                Lord Krishna
                <br />
                <br />
                <b>Alankara Seva – </b>Contribute to the festival deity
                decorations <br /> <br />
                <b>Pushpanjali Seva – </b> Offer fragrant flowers at the lotus
                feet of Lord Krishna as an expression of your heartfelt <br />
                devotion. <br />
                <a href="https://www.iskconvijayawada.org/janmashtami2025">
                  <b> Gau Seva – </b>{" "}
                </a>
                Serve and honour Krishna’s beloved cows by sponsoring their care
                and nourishing them with love and gratitude. <br />
              </p>
              <br />
              <h3>How You Can Be Part of This Divine Festival</h3>
              <br />
              <p>
                ● Attend the 3-day Janmashtami celebrations at both ISKCON Sri
                Jagannath Mandir and Sri Radha Shyamsundar Mandir.
                <br />
                <br />
                ● Participate in sacred rituals like Kalashabhishekam, Maha
                Abhishekam, and Midnight Arati.
                <br />
                <br />
                ● Sponsor special sevas such as Annadana Seva, Pushpa Seva, and
                Alankara Seva.
                <br />
                <br />
                ● Serve Krishna’s cows by contributing to Gau Seva and receive
                lasting spiritual blessings
                <br />
              </p>
              <br />
              <h3>Why Celebrate Janmashtami at ISKCON Vijayawada?</h3>
              <br />
              <p>
                <p>
                  Janmashtami becomes truly special when celebrated where
                  devotion meets tradition — at ISKCON Vijayawada. Here, the
                  festival is not just a ritual, but a spiritual experience that
                  engages the heart, mind, and soul. With inspiring kirtans,
                  lectures on Krishna pastimes, and unlimited prasadam, the
                  atmosphere overflows with spiritual joy. ISKCON Vijayawada
                  follows the pure{" "}
                </p>
                <br />
                <b>Gaudiya Vaishnava tradition, </b> making every offering
                deeply authentic and pleasing to Lord Krishna.
                <br />
                <br />
                <h4>Stay Connected</h4>
                <p>
                  Follow ISKCON Vijayawada on social media for live updates,
                  darshan images, and event videos:
                </p>
                Facebook:{" "}
                <a href="https://www.facebook.com/iskconvja1?mibextid=kFxxJD">
                  <b> @iskconvijayawada </b>{" "}
                </a>
                <br />
                Instagram:{" "}
                <a href="https://www.instagram.com/iskconvijayawada/?igsh=bGZ2aWo1ejd6bDRp#">
                  {" "}
                  <b> @iskconvijayawada </b>
                </a>
                <br />
                YouTube:{" "}
                <a href="https://www.youtube.com/@chakradharidas">
                  <b> ISKCON Vijayawada </b>{" "}
                </a>
                <br />
              </p>
              <br />
              <h3>Don’t Miss the Spiritual Night of the Year! </h3>
              <p>
                Mark your calendar and bring your family and friends. Let’s come
                together in joy and devotion to celebrate the divine appearance
                of Lord Sri Krishna. May your heart be filled with Krishna’s
                mercy and bliss!
              </p>
              <br />
              <h4>Hare Krishna! We welcome you all!</h4>
              <br />
              <h3>Frequently Asked Questions (FAQs)</h3>
              <h5>
                Q1. When and where is Janmashtami being celebrated by ISKCON
                Vijayawada in 2025?
              </h5>
              <p>
                A: The celebrations will be held from 15th to 17th August 2025
                at two locations: Sri Jagannath Mandir in Krishnalanka and Sri
                Radha Shyamsundar Mandir in Undavalli, Vijayawada.
              </p>{" "}
              <h5>
                Q2. How can I participate in special sevas during the festival?{" "}
              </h5>
              <p>
                A: You can sponsor or participate in various sevas such as
                Abhishekam, Annadanam, Pushpa Seva, and Gau Seva. Seva details
                and booking options are available on{" "}
                <a href="https://www.iskconvijayawada.org/janmashtami2025">
                  <b>https://www.iskconvijayawada.org/janmashtami2025</b>
                </a>{" "}
                <br />
                <br />{" "}
                <h5>Q3. How can I take part in Gau Seva during Janmashtami?</h5>
                <p>
                  A: You can support Krishna’s cows by sponsoring services such
                  as cow adoption, monthly feeding, green and dry grass supply,
                  or medical care. Gau Seva is one of the most pleasing
                  offerings to Lord Krishna and brings immense spiritual
                  benefit.
                </p>
              </p>
              <br />
            </div>
          </div>

          <div id="side-bar-section">
            <RecentBlogs />
          </div>
        </main>
      </div>
      <Footer />
    </>
  );
};

export default Janmashtami;
